import { render, staticRenderFns } from "./main.vue?vue&type=template&id=87e0eb54"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87e0eb54')) {
      api.createRecord('87e0eb54', component.options)
    } else {
      api.reload('87e0eb54', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=87e0eb54", function () {
      api.rerender('87e0eb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/basic/carousel/src/main.vue"
export default component.exports